import { Route, Routes } from "react-router-dom";

import "./App.css";
import Maintenance from "./pages/Maintenance";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Maintenance />} />
      </Routes>
    </div>
  );
}

export default App;
